var _rect, _path, _path2, _path3, _path4, _line, _line2, _line3, _line4, _path5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSignIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 155,
    height: 155,
    viewBox: "0 0 155 155",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 155,
    height: 155,
    rx: 12,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39 55.8284C39 55.5632 39.1054 55.3089 39.2929 55.1213L59.1213 35.2929C59.3089 35.1054 59.5632 35 59.8284 35H99C102.866 35 106 38.134 106 42V114C106 117.866 102.866 121 99 121H46C42.134 121 39 117.866 39 114V55.8284Z",
    fill: "#E8E8FD",
    stroke: "#795AF7",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1213 55.7071C39.7308 55.3166 39.7308 54.6834 40.1213 54.2929L58.2929 36.1213C58.6834 35.7308 59.3166 35.7308 59.7071 36.1213L60.4142 35.4142L59.7071 36.1213L60 36.4142V53C60 54.6569 58.6569 56 57 56H40.4142L40.1213 55.7071Z",
    fill: "#A5A6F6",
    stroke: "#795AF7",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M106.544 104.929L106.713 104.898L106.861 104.812L134.141 89.0622C135.576 88.2338 136.067 86.399 135.239 84.9641L134.239 83.2321C133.411 81.7972 131.576 81.3055 130.141 82.134L102.861 97.884L102.713 97.9696L102.601 98.0998L98.5826 102.795C97.3558 104.229 98.6138 106.408 100.469 106.062L106.544 104.929Z",
    fill: "#795AF7",
    stroke: "white",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M79 96.5011C80.5 95.5 83.0969 96.5965 82 99.4992C80 104.792 81.2211 106.629 83 106C85 105.293 85.25 100.855 87.5 101.207C89.75 101.56 89.1665 105.536 88 105.707C86 106.001 91.5 102.001 96 105.707",
    stroke: "#795AF7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 50,
    x2: 75,
    y2: 50,
    stroke: "#795AF7",
    strokeWidth: 2
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 56,
    x2: 75,
    y2: 56,
    stroke: "#795AF7",
    strokeWidth: 2
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 75,
    x2: 50,
    y2: 75,
    stroke: "#795AF7",
    strokeWidth: 2
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 95,
    y1: 81,
    x2: 50,
    y2: 81,
    stroke: "#795AF7",
    strokeWidth: 2
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M75 87L50 87",
    stroke: "#795AF7",
    strokeWidth: 2
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignIcon);
export default __webpack_public_path__ + "static/media/sign-icon.7defce7f931e665f5c5dd17440ca8b53.svg";
export { ForwardRef as ReactComponent };